import { createContext, FC, ReactNode, useContext, useState } from 'react'

interface SearchContextType {
  isVisible: boolean
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>
}

const SearchContext = createContext<SearchContextType | undefined>(undefined)

const SearchProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <SearchContext.Provider value={{ isVisible, setIsVisible }}>
      {children}
    </SearchContext.Provider>
  )
}

const useSearchDialog = () => {
  const context = useContext(SearchContext)
  if (!context) {
    throw new Error('useSearchDialog must be used within SearchProvider')
  }
  return context
}

type SearchProviderType = { Provider: typeof SearchProvider }

export { SearchProvider, useSearchDialog, type SearchProviderType }
